export default "__VITE_ASSET__799a0411__"